const moveActivePracticeIndexReducer = (state = 0, action = {}) => {
    if (action.type === 'MOVE_PRACTICE_QUESTION_INDEX') {
        return action.payload;
    }
    return state;
}

export default moveActivePracticeIndexReducer;
